// extracted by mini-css-extract-plugin
export default {"input":"NewOrganizationForm_input__QPSKz","description":"NewOrganizationForm_description__7rWIQ","errors":"NewOrganizationForm_errors__j4CU0"};